<template>
  <el-dialog
    width="60%"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    destroy-on-close
    @close="closeDialog"
  >
    <div slot="title">
      {{ $t('storage::commodity-stocks::stock_flow') }}
    </div>
    <el-form>
      <el-form-item label="SPU:">
        {{ sku.spu }}
      </el-form-item>
      <el-form-item label="SKU:">
        {{ sku.sku }}
      </el-form-item>
      <el-form-item :label="$t('storage::commodity-stocks::stock_flow_product_name')">
        {{ sku.productName }}
      </el-form-item>
    </el-form>
    <z-table
      :columns="tableColumns"
      :data="tableData"
      :max-height="300"
      v-loading="loading"
      :pagination.sync="pagination"
      @page-change="handlePageChange"
    >
      <template #changeValue="{ row }">
        <span :style="`color:${compareCount(row.type)}`">
          {{ (row.type === '1' ? '+' : '-') + $dataCheck(row.changeValue, '--') }}
        </span>
      </template>
      <template #changeTime="{ row }">
        <span>
          {{ getDate(row.changeTime) }}
        </span>
      </template>
    </z-table>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="dialogVisible = false" size="medium">
        导出流水
      </el-button> -->
      <el-button type="primary" size="medium" @click="dialogVisible = false">
        {{ $t('storage::commodity-stocks::stock_flow_close') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getStockFlow } from '@/server/data'
import { STOCKS_FLOW_COLUMNS } from '../config'
export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    sku: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      tableColumns: STOCKS_FLOW_COLUMNS,
      pagination: {
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0
      }
    }
  },
  watch: {
    visible(bool) {
      this.dialogVisible = bool
      if (!bool) {
        this.closeDialog()
        this.pagination = {
          pageNum: 1, // 页码
          pageSize: 20, // 每页大小
          total: 0
        }
        this.tableData = []
      } else {
        this.getStockFlow()
      }
    }
  },
  methods: {
    getDate(date) {
      return date
    },
    async getStockFlow() {
      this.loading = true
      const { data } = await getStockFlow({ sku: this.sku.sku, pageInfo: { ...this.pagination } })
      if (data.code === this.$code) {
        this.tableData = data.data.datas
      }
      this.loading = false
    },
    compareCount(type) {
      if (type === '1') {
        return '#67C23A'
      } else if (type === '2') {
        return '#ff3c2a'
      } else {
        return 'inheirt'
      }
    },
    handlePageChange() {
      this.getStockFlow()
    },
    closeDialog(refresh) {
      this.$emit('closeDialog', refresh)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    max-height: 550px;
    overflow-y: auto;
  }
}
::v-deep.el-form-item {
  margin-bottom: 0;
}
::v-deep.el-form-item__label {
  color: inherit;
}
.el-form-item {
  width: 500px;
}
</style>
